import SubCategory from 'components/Layout/Header/HeaderBottom/DesktopMenu/SubCategory/SubCategory';
import { useNavigationSubCategoriesApi } from 'graphql/generated';
import Skeleton from 'react-loading-skeleton';
import { twJoin } from 'tailwind-merge';

type SubCategoriesProps = {
    activeCategory: string;
};

const SubCategories: FC<SubCategoriesProps> = ({ activeCategory }) => {
    const [{ data, fetching }] = useNavigationSubCategoriesApi({ variables: { uuid: activeCategory } });

    if (!data?.category?.children.length && !fetching) {
        return null;
    }

    return (
        <ul className={twJoin('block flex-1 columns-3 gap-8 px-8 pt-8')}>
            {!fetching
                ? data?.category?.children.map((item, index) => (
                      <SubCategory key={index} className="break-inside-avoid" item={item} />
                  ))
                : Array(5)
                      .fill(null)
                      .map((_, index) => (
                          <div key={index} className="flex gap-3 pb-7 pl-16">
                              <Skeleton baseColor="#e5e5e5" className="h-20 w-20" highlightColor="#ececec" />
                              <div className="flex flex-col gap-2">
                                  <Skeleton baseColor="#e5e5e5" className="h-3 w-32" highlightColor="#ececec" />
                                  <Skeleton baseColor="#e5e5e5" className="h-3 w-16" highlightColor="#ececec" />
                                  <Skeleton baseColor="#e5e5e5" className="h-3 w-20" highlightColor="#ececec" />
                                  <Skeleton baseColor="#e5e5e5" className="h-3 w-20" highlightColor="#ececec" />
                              </div>
                          </div>
                      ))}
        </ul>
    );
};

export default SubCategories;
